import React, { Component } from "react";
import "./OwActionBar.scss";

import * as _ from "lodash-es";
import IAction from "../../../models/IAction";
import IColumns from "../../../models/IColumns";
import ISupplierModel from "../../../models/ISupplierModel";
import UIService from "../../../services/UIService";
import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import { TableColumnSelect } from "../TableColumnSelect/TableColumnSelect";
import SortOrderEnum from "../../../models/SortOrderEnum";

type Props = {
    actions: IAction[];
    disabled: boolean;
    selectedItem: any;
    isQuotes?: boolean;
    isTemplates?: boolean;
    toggleSmallTable: (isSmallTable: boolean) => void;
    togglePhotoView?: (isPhotoView: boolean) => void;
    columns: IColumns;
    colToggledFn: (columns: IColumns) => void;
    hideTableTypeSelect?: boolean;
    hideColumnToggle?: boolean;
    supplierModel?: ISupplierModel;
    totalValue?: string | number;
    saveAsDefaultsFn?: (columns: IColumns, sortCol?: string, sortOrder?: SortOrderEnum) => void;
    sortCol?: string;
    sortOrder?: SortOrderEnum;
    availSortCol?: { title: string; value: string }[];
};

type State = {
    isSmallTable: boolean;
    isPhotoView: boolean;
};

class OwActionBar extends Component<Props, State> {
    static defaultProps = {
        actions: [],
        selectedItem: null,
        disabled: true,
        isQuotes: false,
    };

    readonly state: State = {
        isSmallTable: true,
        isPhotoView: false,
    };

    getTotalActionButtons = (): number => {
        let count = 0;

        for (const action of this.props.actions) {
            if (action.isGroup) {
                if (action.groupActions) {
                    for (const groupAction of action.groupActions) {
                        count = count + 1;
                    }
                }
            } else {
                count = count + 1;
            }
        }

        return count;
    };

    createActionButton = (action: IAction, index: number, totalGroupActions?: number) => {
        let disabled = this.props.disabled;
        let isActive = false;

        if (action.disabledFn && _.isFunction(action.disabledFn)) {
            disabled = action.disabledFn(null);
        }

        if (action.isActive) {
            if (_.isFunction(action.isActive)) {
                isActive = action.isActive(action.name);

                if (isActive) {
                    disabled = true;
                }
            } else if (!_.isFunction(action.isActive) && action.isActive) {
                isActive = disabled = true;
            }
        }

        let mr = "me-2";

        if (this.getTotalActionButtons() - 1 === index) {
            mr = "";
        }

        if (totalGroupActions) {
            // If the last action, then remove the margin-right
            if (totalGroupActions - 1 === index) {
                mr = "";
                // If the only action, don't show the margin-right
            } else if (totalGroupActions === 1) {
                mr = "";
            }
        }

        let name: any = action.name;

        if (action.isSupplierVendorOverride && !_.isNil(this.props.supplierModel)) {
            if (!_.isNil(this.props.supplierModel.vendor_name_override)) {
                name = name.replace(/vendor/g, this.props.supplierModel.vendor_name_override);
            }

            // if (name.length) {
            //     name = <FormattedMessage id={name} defaultMessage={`_${name}_`} description={name} />;
            // }
        }

        const isOpen = action.isOpen ? action.isOpen() : false;

        let openActiveStateClass = "";

        if (isOpen) {
            openActiveStateClass = "active";
        }

        let btnClass = "";

        if (action.btnClass) {
            if (_.isFunction(action.btnClass)) {
                // @ts-expect-error
                btnClass = action.btnClass();
            } else {
                // @ts-expect-error
                btnClass = action.btnClass;
            }
        }

        return (
            <OwButton
                id={action.id}
                key={index}
                className={`btn-sm ${mr} mb-2 mb-md-0 ${openActiveStateClass} ${btnClass ? btnClass : "btn-primary"}`}
                fn={action.fn}
                disabled={disabled}
                title={name}
                active={isActive}
                leftIconClass={action.leftIconClass}
            />
        );
    };

    getActionItems = () => {
        return _.map(this.props.actions, (action, index) => {
            if (action.isGroup && action.groupActions) {
                const groupButtons = action.groupActions.map((groupAction: IAction, groupIndex: number) => {
                    return this.createActionButton(groupAction, groupIndex, action.groupActions!.length);
                });

                const fieldset = (
                    <fieldset key={index} className={" border p-2 me-1"}>
                        <legend className={"mb-0 w-auto"}>
                            <OwLabel className={"ps-1 pe-1 text-small"} title={action.name} noBottomMargin={true} />
                        </legend>
                        <div>{groupButtons}</div>
                    </fieldset>
                );

                return fieldset;
            } else {
                return this.createActionButton(action, index);
            }
        });
    };

    toggleSmallTable = (isSmallTable: boolean) => {
        this.setState(
            {
                isPhotoView: false,
                isSmallTable,
            },
            () => {
                this.props.toggleSmallTable(isSmallTable);
            }
        );
    };

    togglePhotoView = (isPhotoView: boolean) => {
        this.setState(
            {
                isPhotoView: true,
                isSmallTable: false,
            },
            () => {
                if (this.props.togglePhotoView) {
                    this.props.togglePhotoView(true);
                }
            }
        );
    };

    render() {
        let actionItems: any = this.getActionItems();

        if (this.props.isQuotes) {
            // actionItems = null;
        }

        if (this.props.isTemplates) {
            actionItems = [];
        }

        let hasGroupActions = false;

        for (const action of this.props.actions) {
            if (action.isGroup) {
                hasGroupActions = true;
            }
        }

        let cardClass = "dark-card";

        if (UIService.isMainViewLight()) {
            cardClass = "";
        }

        return (
            <div className={"OwActionBar " + cardClass}>
                <div className={"card-body p-2 " + (hasGroupActions ? "align-items-end" : "")}>
                    <div className={"action-items d-flex align-items-end"}>{actionItems}</div>
                    <div className={"table-items"}>
                        {this.props.totalValue ? (
                            <div className={"mb-2"}>
                                <OwLabel title={"total_rows"} postText={":"} noBottomMargin={true} className={"me-2"} />
                                {this.props.totalValue}
                            </div>
                        ) : null}
                        <div className={"d-flex"}>
                            {this.props.hideTableTypeSelect ? null : (
                                <div>
                                    <div className={"btn-group"}>
                                        <OwButton
                                            className={
                                                "btn-primary " + (this.state.isPhotoView ? "" : this.state.isSmallTable ? "active" : "")
                                            }
                                            title={""}
                                            centerIconClass={"fad fa-list-alt"}
                                            fn={() => {
                                                this.toggleSmallTable(true);
                                            }}
                                        />
                                        <OwButton
                                            className={
                                                "btn-primary " + (this.state.isPhotoView ? "" : this.state.isSmallTable ? "" : "active")
                                            }
                                            title={""}
                                            centerIconClass={"fad fa-list"}
                                            fn={() => {
                                                this.toggleSmallTable(false);
                                            }}
                                        />
                                        {this.props.togglePhotoView ? (
                                            <OwButton
                                                className={"btn-primary " + (this.state.isPhotoView ? "active" : "")}
                                                title={""}
                                                centerIconClass={"fad fa-image"}
                                                fn={() => {
                                                    this.togglePhotoView(true);
                                                }}
                                            />
                                        ) : null}
                                    </div>
                                </div>
                            )}
                            {this.props.hideColumnToggle ? null : (
                                <div className={"ms-2"}>
                                    <TableColumnSelect
                                        className={"table-column-select"}
                                        columns={this.props.columns}
                                        colToggledFn={this.props.colToggledFn}
                                        saveAsDefaultFn={this.props.saveAsDefaultsFn}
                                        sortCol={this.props.sortCol}
                                        sortOrder={this.props.sortOrder}
                                        availSortCol={this.props.availSortCol}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OwActionBar;
